import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from './slices/authSlice';
import promptPropertiesReducer from './slices/promptPropertiesSlice';
import sidePanelReducer from './slices/sidePanelSlice';
import toastReducer from './slices/toastSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    promptProperties: promptPropertiesReducer,
    sidePanel: sidePanelReducer,
    toast: toastReducer
});

const store =  configureStore({
    reducer: rootReducer
})

export default store;